export class GameEventsConstants {
    static readonly hitStart = 'hitStart';
    static readonly directionChangeStart = 'directionChangeStart';
    static readonly hitEnd = 'hitEnd';
    static readonly preventStart = 'preventStart';
    static readonly updateScores = 'updateScores';

}